<template>
  <div class="add-user-modal">
    <v-dialog v-model="dialog" max-width="550">
      <v-card>
        <v-card-title class="headline"
          >Are you sure you want to delete <b class="pl-2">{{ name }}</b
          >?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="$emit('clicked-no', id)">
            No
          </v-btn>
          <v-btn :loading="loader" color="green darken-1" text @click="$emit('clicked-yes', id)">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "ConfirmDeleteDialog",
  data() {
    return {
      dialog: true,
      isAddUserFormLoading: false
    };
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    id: {
      type: Number,
      default: null
    },
    loader: {
      type: Boolean,
      default: false
    }
  },
  methods: {}
};
</script>
